import { render, staticRenderFns } from "./symptoms.vue?vue&type=template&id=20539c5d"
import script from "./symptoms.vue?vue&type=script&lang=js"
export * from "./symptoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports